import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const RequestSubmittedStep = () => {
  const url = `/projects/`;
  const { t } = useTranslation();

  return (
    <>
      <p>{t('getProjectUp')}</p>
      <p>{t('sharePointFolder')}</p>
      <br />
      <div className="separator" />
      <p className="link-projects-list">
        <Link to={url} className="btn btn-primary" aria-label="Projects">
          {t('projectList')}
        </Link>
      </p>
    </>
  );
};

export default RequestSubmittedStep;
